import { connect } from 'react-redux'
import { PrivateRoute } from './PrivateRouteInner'
import { mapStateToProps } from './store'

export { PrivateRoute }

export default connect(mapStateToProps)(PrivateRoute)
